module.exports = __webpack_public_path__ + "static/media/refresh.aa77e734.svg";